import styled from 'styled-components';

export const BankIntegrationFLexContainer = styled.div
.attrs(() => ({
  className: 'white mt-25',
}))`
    border-radius: 10px;
    // background: #FFF;
    border:2px dashed red;
    width:100%;
    padding:29px 28px;
    displa
`;


export const BankTab= styled.div
.attrs(() => ({
  className: 'white mt-25',
}))`
    width:360px;
    min-height: 91px;
    background: #FFFFFF;
    box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.03);
    border-radius: 10px;
    margin-right:20px;
    padding:8px 16px;
    h5{
      color: #71717A;
      font-family: Plus Jakarta Sans;
      font-size: 13px !important;
      font-style: normal;
      font-weight: 500;
      text-transform: uppercase;
    }
    .value{ 
      font-family: 'Plus Jakarta Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 21px;
      color: #18181B;
    }
    h6{
        font-family: 'Plus Jakarta Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        // color: #22C55E;
    }
    @media only screen and (max-width: 992px) {
      width: 100% !important;
      margin:16px;
    }
`;

export const BankCardTabs= styled.div
.attrs(() => ({
  className: 'white mt-25',
}))`
    width: 294px ;
    // flex:1;
    min-height: 91px;
    background: #FFFFFF;
    box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.03);
    border-radius: 10px;
    margin-right:20px;
    padding:8px 16px;
    h5{
      color: #71717A;
      font-family: Plus Jakarta Sans;
      font-size: 13px !important;
      font-style: normal;
      font-weight: 500;
      text-transform: uppercase;
    }
    .value{ 
      font-family: 'Plus Jakarta Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 21px;
      color: #18181B;
    }
    h6{
        font-family: 'Plus Jakarta Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        // color: #22C55E;
    }
    @media only screen and (max-width: 600px) {
      width: 100% !important;
    
    }
    @media only screen and (max-width: 992px) {
      // styles for medium screens and down
      width: 100% !important;
      margin:16px;
      // background: red;
    }
   
`;
